import { request } from '@/utils/axios'

/* 榜样6 */
export function getLivingPath () {
  return request({
    url: '/api/Main/LiveVideo',
    method: 'get'
  })
}
